import React from "react";
import PropTypes from "prop-types";
import { Modal, Button, Form, Dropdown } from "react-bootstrap";
import "../../assets/css/AttachmentModal.css";

const AttachmentModal = ({
  show,
  onHide,
  attachmentUrl,
  acknowledge,
  setAcknowledge,
  currentStatus,
  reimbursementId,
  reimbursementStatusIdHandler,
  config,
}) => {
  const statusOptions = [
    { value: 1, label: "Pending", className: "text-info" },
    { value: 2, label: "Approve", className: "text-success" },
    { value: 3, label: "Reject", className: "text-danger" },
  ];

  const getStatusInfo = () => {
    return (
      statusOptions.find((option) => option.value === currentStatus) ||
      statusOptions[0]
    );
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      fullscreen
      aria-labelledby="attachment-modal-title"
      className="attachment-modal"
    >
      <Modal.Header>
        <Modal.Title id="attachment-modal-title">
          Uploaded Attachment
        </Modal.Title>
        <Button
          variant="link"
          onClick={() => {
            setAcknowledge(false);
            onHide();
          }}
          className="modal-close-btn"
        >
          <i class="fa-solid fa-rectangle-xmark"></i>
        </Button>
      </Modal.Header>

      <Modal.Body className="d-flex justify-content-center">
        <img
          src={`${config.IMAGE_URL}${attachmentUrl}`}
          alt="Attachment"
          className="attachment-image"
        />
      </Modal.Body>

      <Modal.Footer>
        <div className="d-flex align-items-center gap-2">
          <Form.Check
            type="checkbox"
            checked={acknowledge || currentStatus !== 1}
            onChange={(e) => setAcknowledge(e.target.checked)}
            disabled={currentStatus !== 1}
            label="I have reviewed and acknowledge this attachment."
          />
        </div>

        {acknowledge && (
          <Dropdown>
            <Dropdown.Toggle
              variant="outline-secondary"
              size="sm"
              className="status-dropdown"
            >
              <i
                className={`far fa-dot-circle ${getStatusInfo().className}`}
              ></i>
              {getStatusInfo().label}
            </Dropdown.Toggle>

            <Dropdown.Menu align="end">
              {statusOptions.map((option) => (
                <Dropdown.Item
                  key={option.value}
                  onClick={(e) => {
                    e.preventDefault();
                    if (option.value !== currentStatus) {
                      reimbursementStatusIdHandler(
                        option.value,
                        reimbursementId,
                        "REIMBURSEMENT"
                      );
                    }
                  }}
                >
                  <i className={`far fa-dot-circle ${option.className}`}></i>{" "}
                  {option.label}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        )}
      </Modal.Footer>
    </Modal>
  );
};

AttachmentModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  attachmentUrl: PropTypes.string.isRequired,
  acknowledge: PropTypes.bool.isRequired,
  setAcknowledge: PropTypes.func.isRequired,
  currentStatus: PropTypes.number.isRequired,
  reimbursementId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  reimbursementStatusIdHandler: PropTypes.func.isRequired,
  config: PropTypes.shape({
    IMAGE_URL: PropTypes.string.isRequired,
  }).isRequired,
};

export default AttachmentModal;
